import { useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { login as loginService } from "../services/login";
import { setAuthorization } from "../helpers/api_helper";
import { clearStoredAuthUser, persistAuthUser } from "../utils/backendApi";

export const useLogin = (options = {}) => {
  const history = useHistory();

  const mutation = useMutation({
    mutationFn: async ({ email, password }) => {
      const data = await loginService(email, password);
      return data;
    },
    onSuccess: (data, variables, context) => {
      if (data) {
        persistAuthUser(data);
        if (data.access) {
          setAuthorization(data.access);
        }
      }
      // A deep link opened in a fresh tab lands on the login page with the
      // requested location in state (AuthProtected): return there afterwards.
      history.push(history.location?.state?.from?.pathname || "/dashboard");
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      if (options.onError) {
        options.onError(error, variables, context);
      }
    },
  });

  return mutation;
};

export const useLogout = () => {
  const history = useHistory();

  const logout = () => {
    clearStoredAuthUser();
    setAuthorization(null);
    const lang = localStorage.getItem("i18nextLng");
    if (lang === "fr" || lang === "Fr") {
      history.push("/fr/connexion");
    } else if (lang === "en" || lang === "En") {
      history.push("/en/login");
    } else {
      history.push("/fr/connexion");
    }
  };

  return logout;
};
